export class Reflection {
    public static getPropertyName<T = any | object>(propertyFunction: (a: T) => any): string {
        const fn = propertyFunction.toString();
        const classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s+[$_\w\d]+\.([.$_\w\d]+)\s*;?\s*\}$/;
        //let classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s+[$_\w\d]+\.([$_\w\d]+)\s*;?\s*\}$/;
        const arrow = /^\(?[$_\w\d]+\)?\s*=>\s*[$_\w\d]+\.([$_\w\d]+)$/;
        const regexResult = classic.exec(fn) || arrow.exec(fn);
        return regexResult && regexResult[1] ? regexResult[1].replace(";", "") : undefined;
    }

    public static getPropertyPath<T = any | object>(propertyFunction: (a: T) => any): string {
        const fn = propertyFunction.toString();
        const classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s*([$_.\w\d[\w\d\]]+)\s*;?\s*\}$/;
        const arrow = /^\(?[$_\w\d]+\)?\s*=>\s*([$_.\w\d[\w\d\]]+)$/;
        const regexResult = classic.exec(fn) || arrow.exec(fn);
        const parts = regexResult[1].split('.');
        const path = parts.slice(1).join('.');
        return path;
    }

    public static getPropertiesNames<T = any | object>(propertyFunctions: ((a: T) => any)[]): string[] {
        const properties: string[] = [];
        propertyFunctions.forEach(x => {
            properties.push(Reflection.getPropertyName(x));
        });
        return properties;
    }

    public static kebabCase(str: string) {
        const kebabCase = str.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
        return kebabCase;
    }

    public static camelCase(str: string): string {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index: number) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }

    public static unCamelCase<T = any | object>(propertyGetter: ((a: T) => any) | string, titlize: boolean = true) {
        let propertyName = null;
        if (typeof propertyGetter == "function") {
            propertyName = Reflection.getPropertyName(propertyGetter);
        } else {
            propertyName = propertyGetter;
        }

        if (titlize) {
            return propertyName
                // insert a space between lower & upper
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                // space before last upper in a sequence followed by lower
                .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
                // uppercase the first character
                .replace(/^./, function (str) { return str.toUpperCase(); })
        }
        else {
            return propertyName
                // uppercase the first character
                .replace(/^./, function (str) { return str.toUpperCase(); })
        }
    }

    public static getPropertiesOfObject(object: any): string[] {
        const result: string[] = [];
        if (!object) {
            return result;
        }

        if (typeof object === "object") {
            for (const i of Object.keys(object)) {
                result.push(i);
            }
        }
        return result;
    }
}

export class NotifyPropertyChangedBase {
    public changes: any = {};
    onPropertyChanged<T>(propertyFunction: (x: T) => any) {
        const prop = Reflection.getPropertyName(propertyFunction);
        this.changes[prop] = !this.changes[prop];
    }
}
